// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QCntqo5N{padding:25px 10px 25px 20px !important}.QCntqo5N .Lc2blKX8{top:15px;right:10px}`, "",{"version":3,"sources":["webpack://./src/fsd/pages/mutual-settlements/ui/MutualSettlementsModal/MutualSettlementsModal.module.scss"],"names":[],"mappings":"AAAA,UACE,sCAAA,CAEA,oBACE,QAAA,CACA,UAAA","sourcesContent":[".modal {\n  padding: 25px 10px 25px 20px !important;\n\n  .close {\n    top: 15px;\n    right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `QCntqo5N`,
	"close": `Lc2blKX8`
};
export default ___CSS_LOADER_EXPORT___;
